module.exports = __webpack_public_path__ + "img/logo.53c0b199.png";